export enum Type {
  EPISODE_WIZARD_CREATE_REQUEST = 'app/episode-wizard/EPISODE_WIZARD_CREATE_REQUEST',
  EPISODE_WIZARD_CREATE_SUCCESS = 'app/episode-wizard/EPISODE_WIZARD_CREATE_SUCCESS',
  EPISODE_WIZARD_CREATE_FAILURE = 'app/episode-wizard/EPISODE_WIZARD_CREATE_FAILURE',

  EPISODE_WIZARD_CLEAR = 'app/episode-wizard/EPISODE_WIZARD_CLEAR',
}
